export const GEAR_CARD_WIDTH = 230;
export const GEAR_CARD_HEIGHT = 290;

export const PBC_DEALS_DEFAULT_CATEGORY_IDS = [505, 607, 608] as const;

export const DEFAULT_PBC_DEALS_LIMIT = 12;

export const GEAR_GRID_VISIBLE_CELL_LIMIT = 8;
